import BOTFavoritesNotification from './BOTFavoritesNotification'
import { showNotification } from './helpers'

export default BOTFavoritesNotification

export { showNotification }
